// Homepage CRO measurement: experiment metrics to Intelligems, qualitative segmentation to Clarity.
(function () {
  'use strict';

  if (window.__rpmCroMeasurement) return;
  window.__rpmCroMeasurement = true;

  var GRID_LINK_SELECTOR = 'a.collection-item, a.rpm-make';
  var HERO_SECTION_SELECTOR = '[data-section-type="slideshow-section"]';
  var HERO_SLIDE_SELECTOR = '.slideshow__slide';
  var SELECTED_SLIDE_CLASS = 'is-selected';
  var SLIDE_CLASS = 'slideshow__slide';

  // Not rpm:garage:loaded — that fires for anyone with a saved machine, who did nothing.
  var MACHINE_SELECTED_EVENT = 'rpm:machine:selected';

  function igEvent(name) {
    if (!name) return;
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: name });
    } catch (_) {}
  }

  function claritySet(detail) {
    if (typeof window.clarity !== 'function' || !detail) return;
    try {
      Object.keys(detail).forEach(function (key) {
        window.clarity('set', key, String(detail[key]));
      });
    } catch (_) {}
  }

  function clarityEvent(name, detail) {
    if (typeof window.clarity !== 'function' || !name) return;
    // Tags first, in their own try: a throw from clarity('event') must not discard them.
    claritySet(detail);
    try {
      window.clarity('event', name);
    } catch (_) {}
  }

  function collectionHandle(href) {
    if (!href) return 'unknown';
    var match = href.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : 'unknown';
  }

  function tagVariant() {
    var user = window.igData && window.igData.user;
    if (!user || typeof user.getExperiments !== 'function') return;

    var experiments;
    try {
      experiments = user.getExperiments() || [];
    } catch (_) {
      return;
    }

    experiments.forEach(function (experiment) {
      var group = null;
      try {
        group = user.getTestGroup(experiment.id);
      } catch (_) {}
      if (!group) return;
      claritySet({ ig_experiment: experiment.name, ig_variant: group.name });
    });
  }

  // Exploratory only; the Intelligems click event is the metric of record.
  function onCategoryClick(event) {
    var target = event.target;
    var tile = target && target.closest ? target.closest(GRID_LINK_SELECTOR) : null;
    if (!tile) return;

    var section = tile.closest('.shopify-section');
    clarityEvent('category_grid_click', {
      category_grid_handle: collectionHandle(tile.getAttribute('href')),
      category_grid_section: section && section.id ? section.id : 'unknown'
    });
  }

  // Watches is-selected, not Flickity's change event: this script is deferred and
  // the instance does not exist yet at hookup.
  function watchHeroSlides() {
    var hero = document.querySelector(HERO_SECTION_SELECTOR);
    if (!hero || typeof MutationObserver !== 'function') return;
    var slides = hero.querySelectorAll(HERO_SLIDE_SELECTOR);
    if (!slides.length) return;

    var seen = {};
    function record(slide) {
      var index = parseInt(slide.getAttribute('data-index'), 10);
      if (isNaN(index) || seen[index]) return;
      seen[index] = true;
      igEvent('homepage_hero_slide_' + (index + 1) + '_seen');
    }

    // No change event ever fires for the initial slide.
    record(slides[0]);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var slide = mutation.target;
        // Page dots carry is-selected too.
        if (!slide.classList || !slide.classList.contains(SLIDE_CLASS)) return;
        if (slide.classList.contains(SELECTED_SLIDE_CLASS)) record(slide);
      });
    }).observe(hero, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function init() {
    // onIgReady runs immediately if Intelligems already loaded, so this is race-free.
    var previous = window.onIgReady;
    window.onIgReady = function () {
      if (typeof previous === 'function') {
        try { previous(); } catch (_) {}
      }
      tagVariant();
    };

    document.addEventListener('click', onCategoryClick);
    document.addEventListener(MACHINE_SELECTED_EVENT, function () {
      igEvent('homepage_machine_selector_used');
    }, { once: true });

    watchHeroSlides();
  }

  init();
})();
